import { requestByGet } from "@dage/service";

export const getSceneData = () => {
  return requestByGet("/api/count/saveVisit/SG-SkJEj1Vhf7l");
};
